import * as React from 'react';

import {CHANNELS} from 'nutshell-core/channels/consts';

// @ts-expect-error - imported from .js/.jsx file

import {BrowserIcon} from 'shells/icon/svg/browser-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CompassIcon} from 'shells/icon/svg/compass-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EnvelopeOpenTextIcon} from 'shells/icon/svg/envelope-open-text-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MagnifyingGlassChartIcon} from 'shells/icon/svg/magnifying-glass-chart-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MagnifyingGlassDollarIcon} from 'shells/icon/svg/magnifying-glass-dollar-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MessagesDollarIcon} from 'shells/icon/svg/messages-dollar-icon';
// @ts-expect-error - imported from .js/.jsx file
import {MessagesIcon} from 'shells/icon/svg/messages-icon';
// @ts-expect-error - imported from .js/.jsx file
import {TVRetroIcon} from 'shells/icon/svg/tv-retro-icon';
import {Link} from 'shells/link/link';

import type {ChannelType} from 'nutshell-graphql-types';

export const getIconFromChannelType = (
    channel: ChannelType
): React.ComponentType<any> | null | undefined => {
    switch (channel) {
        case 'SEARCH_ORGANIC':
            return MagnifyingGlassChartIcon;
        case 'SEARCH_PAID':
            return MagnifyingGlassDollarIcon;
        case 'SOCIAL_ORGANIC':
            return MessagesIcon;
        case 'SOCIAL_PAID':
            return MessagesDollarIcon;
        case 'EMAIL':
            return EnvelopeOpenTextIcon;
        case 'DIRECT_TO_WEBSITE':
            return CompassIcon;
        case 'REFERRER':
            return BrowserIcon;
        case 'TRADITIONAL':
            return TVRetroIcon;
        case 'UNKNOWN':
        default:
            return undefined;
    }
};

const linkToArticle = (
    <Link
        href='https://support.nutshell.com/en/articles/8429026-nutshell-analytics-tracking-website-visitors'
        variant='primary'
        newTab={true}
        size='small'
    >
        Nutshell Analytics
    </Link>
);

export const getHelpInfoFromChannelType = (channel: ChannelType): React.ReactElement => {
    const infoWithLink = (
        <div>
            Leads in the <strong>{CHANNELS[channel].title.toLowerCase()}</strong> channel are
            tracked automatically with {linkToArticle}.
        </div>
    );

    const infoWithoutLink = (
        <div>
            Leads in the <strong>{CHANNELS[channel].title.toLowerCase()}</strong> channel are
            tracked automatically with manually added sources.
        </div>
    );

    switch (channel) {
        case 'SEARCH_ORGANIC':
        case 'SEARCH_PAID':
        case 'SOCIAL_ORGANIC':
        case 'SOCIAL_PAID':
        case 'EMAIL':
        case 'DIRECT_TO_WEBSITE':
            return infoWithLink;
        case 'REFERRER':
        case 'TRADITIONAL':
            return infoWithoutLink;
        case 'UNKNOWN':
        default:
            // @ts-expect-error
            return '';
    }
};
